/* eslint-disable */
// ApexCharts is loaded via CDN in public/index.html before the app bundle.
if (typeof window !== "undefined" && typeof window.ApexCharts !== "function") {
  console.error(
    "[apexcharts] window.ApexCharts is missing. Check the CDN script in public/index.html."
  );
}

export default function getApexCharts() {
  if (typeof window !== "undefined" && typeof window.ApexCharts === "function") {
    return window.ApexCharts;
  }
  return null;
}
